export default "__VITE_ASSET__CphDgceS__"